module.exports = __webpack_public_path__ + "static/media/Footer_Desktop.3badf028.jpg";